import { Header as H } from 'semantic-ui-react'
import styled from 'styled-components'

export const Header = styled(H)`
  && {
    margin: 0;
  }
`
